<app-page-title [title]="'My Account'"></app-page-title>

<div *ngIf="myAccount$ | async as myAccount">
    <div class="row heading-row">
        <div class="col-lg-8">
            <ng-container *ngIf="myAccount.parentCompanyName?.length > 0">
                <p *ngIf="myAccount.isChildAccountBeingAliased">
                    <button
                        (click)="onNavigateParentClick()"
                        class="btn btn-primary"
                        type="button"
                    >
                        Go back {{myAccount.businessAccountTypeNameMapping?.parentTermName}} Account
                    </button>
                </p>
                <p
                    class="alert alert-info"
                    style="padding: 10px"
                >
                    Your account is currently being managed by <strong>{{myAccount.parentCompanyName}}</strong>.
                    <br /><br />
                    If you have any concern about the management of your account, please contact us immediately.
                </p>
            </ng-container>
            <p>You are signed in as <strong><span class="text-uppercase">{{myAccount.usernameDisplay}}</span> ({{ userEmail$ | async }})</strong>.</p>
            <ul>
                <li *ngIf="showBusinessResource">
                    <a [routerLink]="['/account/business-resource']">Resources</a>
                </li>
                <li *ngIf="myAccount.linkedToActiveBusinessAccount">
                    <a [routerLink]="['/account/edit-business-account-info']">{{myAccount.businessAccountTypeNameMapping.parentTermName}} Account Information</a>
                </li>
                <li>
                    <a [routerLink]="['/account/notification-settings']">Notification Settings</a>
                </li>
                <li>
                    <a [routerLink]="['/account/edit-address']">Add/Update Your Billing/Shipping Information</a>
                </li>
                <li>
                    <a [routerLink]="['/account/change-password']">Change Your Password</a>
                </li>
                <li>
                    <a [routerLink]="['/account/redeem-product-code']">Product Key</a>
                </li>
                <li *ngIf="myAccount.eligibleForScholarship">
                    <a [routerLink]="['/account/apply-scholarship']">Apply For Scholarship</a>
                </li>
                <li *ngIf="myAccount.isAffiliated">
                    <a [routerLink]="['/account/affiliate/dashboard']">Affiliate Program</a>
                </li>
            </ul>
            <div class="links">
                <a
                    *ngIf="brandId === BrandEnum.CELPIP && !myAccount.linkedToActiveBusinessAccount"
                    [routerLink]="['/registration/test-selection']"
                    class="btn btn-primary"
                    data-qa="myAccount-registerCELPIPTestBtn"
                >Register for an official CELPIP Test</a>
                <a
                    *ngIf="brandId === BrandEnum.CAEL && !myAccount.linkedToActiveBusinessAccount"
                    [routerLink]="['/registration/sitting-selection']"
                    class="btn btn-primary"
                    data-qa="myAccount-registerCAELTestBtn"
                >Register for CAEL at a test centre</a>
                <a
                    *ngIf="brandId === BrandEnum.CAEL && !myAccount.linkedToActiveBusinessAccount"
                    [routerLink]="['/registration/sitting-selection-web-delivery']"
                    class="btn btn-primary"
                    data-qa="myAccount-registerCAELTestBtn"
                >Register for CAEL online</a>
                <a
                    [routerLink]="['/product-shopping']"
                    class="btn btn-primary"
                >Shop Study Materials</a>
            </div>
        </div>
        <div
            *ngIf="marketingAd"
            class="col-lg-4"
        >
            <a
                [ngClass]="{'marketAdLink' : !marketingAd.isClickable}"
                *ngIf="marketingAd.isActive && marketingAd.hasImageFile"
                target="{{(marketingAd.shouldOpenInNewWindow)? '_blank' : '_self' }}"
                href={{marketingAd.adLink}}
            ><img
                    class="marketAdImg"
                    [src]="marketingAdImage | safe: 'resourceUrl'"
                /></a>
        </div>
    </div>
    <!-- Business Account -->
    <div *ngIf="myAccount.linkedToActiveBusinessAccount; else nonBusinessAccount">
        <app-business-account-form
            *ngIf="brandId === BrandEnum.CELPIP && businessAccount"
            [countries]="countries"
            [isBusinessAccountEditable]="false"
            [formGroup]="userForm"
        ></app-business-account-form>
        <app-business-account-info
            *ngIf="businessAccount"
            [businessAccount]="businessAccount"
            [businessAccountTypeNameMapping]="myAccount.businessAccountTypeNameMapping"
            [brandId]="brandId"
        ></app-business-account-info>
    </div>

    <ng-template #nonBusinessAccount>
        <!-- Upcoming Test -->
        <div
            class="upcoming-test"
            *ngIf="myAccount.upcomingRegistration && myAccount.upcomingRegistration.regId"
        >
            <app-upcoming-test
                [upcomingRegistration]="myAccount.upcomingRegistration"
                [brandId]="brandId"
                [launchSRDownload]="launchSRDownload"
                [regPoliciesUrl]="regPoliciesUrl"
                [testDayInfoUrl]=testDayInfoUrl
                (confirmEmail)="resendConfirmationEmail($event)"
            >
            </app-upcoming-test>
        </div>

        <!-- My Test Registration -->
        <div *ngIf="myAccount.registrations && myAccount.registrations.length > 0">
            <div class="row">
                <div class="col-md-12">
                    <h5>My test registrations</h5>
                    <table class="table">
                        <thead>
                            <tr>
                                <th class="text-center">Registration #</th>
                                <th class="text-center">Test Date &amp; Location</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                app-my-test-registration
                                *ngFor="let reg of registrations"
                                [reg]="reg"
                                [brandId]="brandId"
                                [regPoliciesUrl]="regPoliciesUrl"
                                [testDayInfoUrl]=testDayInfoUrl
                                (confirmEmail)="resendConfirmationEmail($event)"
                            ></tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </ng-template>
    <app-my-products [products]="myAccount.products"></app-my-products>

    <app-order-history [orders]="myAccount.orderHistory"></app-order-history>

    <app-modal
        #resendConfirmEmail
        [title]="modalTitle"
        [body]="modalBody"
    >
    </app-modal>
</div>
